<template>
  <div>
    <vx-card class="work-experience">
      <heading size="h1" style-size="h4" class="mb-5">Work Experience Checklist</heading>

      <p class="mb-5">Ensure you check all items before you begin your work experience.</p>

      <div class="vs-row" style="display: flex; width: 100%">
        <div class="vs-col vs-xs-12 vs-sm-8 vs-lg-9">
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="1"
              >I have the name of my employer and company.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="2"
              >I have the name of the person I need to contact
              (owner/supervisor/manager).</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="3"
              >I have the address and telephone number of the employer/company.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="4"
              >I know how I will get to and from work.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="5"
              >I have an up-to-date timetable, if travelling by public transport.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="6"
              >I know how long will it take to get to my work experience?</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="7"
              >I know the dates and hours of my work experience.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="8"
              >I have any special clothing/equipment required.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="9"
              >I know the procedures in the event of an accident or emergency in the
              workplace.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="10"
              >I know what materials/information I will need with me on my first day.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="11"
              >I will have access to shops/canteen for meals or a kitchenette if bringing my own
              food.</vs-checkbox
            >
          </p>
          <p class="mb-2">
            <vs-checkbox v-model="checkList" vs-value="12"
              >I have my school/teacher contact number in case a problem arises.</vs-checkbox
            >
          </p>
        </div>
        <div class="vs-col vs-xs-12 vs-sm-4 vs-lg-3 lg:pl-10 sm:pl-5">
          <img
            src="@/assets/images/workplace_preparation/new/checklist.jpg"
            class="img-responsive"
            alt=""
          />
        </div>
      </div>

      <form id="form" class="mt-10" @submit.prevent="save">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-checkbox v-model="data.confirmed" name="confirmed"
              >I have read all the information in this module</vs-checkbox
            >
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full flex justify-between">
            <div>
              <button class="btn btn-primary btn-size-medium mr-3 mb-1">Submit</button>
              <router-link
                to="/student/workplace-preparation"
                class="btn btn-secondary btn-size-medium mb-1"
              >
                Back
              </router-link>
            </div>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { successToast, errorToast } from '@/utils/toast';
import store from '@/store/store';

export default {
  data() {
    return {
      checkList: [],
    };
  },
  computed: {
    data: {
      get: function () {
        return this.getModuleData();
      },
      set: function (d) {
        this.setModuleData(d);
      },
    },

    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isConfirmed() {
      return this.$store.getters['authStudent/preworkWorkplacePreparationModules'][
        this.$route.params.id
      ];
    },
    prework() {
      return this.$store.getters['authStudent/prework'];
    },
  },
  methods: {
    save() {
      if (this.checkList.length !== 12) {
        this.$toast.error('You must complete all the check boxes', errorToast());
        return;
      }
      this.saveModule(this.data);
    },
  },
  watch: {
    'prework.workplace_preparation_modules'() {
      const modules = this.prework.workplace_preparation_modules;
      if (modules && modules[6]) {
        this.data = modules[6];
      }
    },
  },
  mounted() {
    if (this.isConfirmed) this.data.confirmed = true;
  },
  beforeDestroy() {
    this.data.confirmed = false;
  },
  inject: ['saveModule', 'getModuleData', 'setModuleData'],
};
</script>

<style lang="scss">
.vx-card.work-experience .vx-card__body {
  @media (max-width: theme('screens.sm')) {
    padding: 1.5rem 1rem;
  }
}
</style>
